export default {"src":"/pro/_next/static/media/stx.9125b500.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};